import { AbstractControl, ValidationErrors } from '@angular/forms';

export function validPublishNameValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;
  const errors: ValidationErrors = {};

  if (!(value.length >= 4 && value.length <= 64)) {
    errors['invalidNameLength'] = 'Name must be 4-64 characters long';
  }

  if (/^\d+/.test(value)) {
    errors['leadingDigits'] = 'Name cannot start with digits';
  }

  if (/[^a-zA-Z0-9_]/.test(value)) {
    errors['invalidChars'] = 'Name cannot contain special characters or spaces';
  }

  if (/^_+|_+$/.test(value)) {
    errors['leadingOrTrailingUnderscores'] = 'Name cannot have leading or trailing underscores';
  }

  return Object.keys(errors).length > 0 ? errors : null;
}
